<div class="cov-logo">
  <a [routerLink]="[HOME]" class="cov-logo-container">
    <img
      class="cov-logo-image"
      ngSrc="/assets/images/covestro-dark.png"
      alt="Covestro"
      width="90"
      height="90"
      priority
    />
    <p class="cov-logo-name mt-2">Order&#64;&#8203;Covestro</p>
  </a>
</div>
